export default __webpack_public_path__ + "static/media/ph01.3db664ee.png";